import { render, staticRenderFns } from "./FeaturedMemberships.vue?vue&type=template&id=4f6843b3&"
import script from "./FeaturedMemberships.vue?vue&type=script&lang=js&"
export * from "./FeaturedMemberships.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports